import { AggregateRoot } from "../value_objects/aggregate_root";
import type { PascoProps } from "../value_objects/pasco_props";
import type { ProcessingStatus } from "../value_objects/processing_status";
import type { UniqueEntityID } from "../value_objects/unique_entity_Id";
import type { UploadedBy } from "../value_objects/uploaded_by";

// Aggregate Root
export class Pasco extends AggregateRoot<PascoProps> {
    private constructor(props: PascoProps, id?: UniqueEntityID) {
        super(props, id);
    }

    // ✅ Factory method
    static create(props: PascoProps, id?: UniqueEntityID): Pasco {
        return new Pasco(props, id);
    }

    // ✅ Getters
    get pascoId(): string {
        return this._id.toValue();
    }

    get path(): string {
        return this.props.path;
    }

    get courseCode(): string | null {
        return this.props.courseCode;
    }

    get courseName(): string | null {
        return this.props.courseName;
    }

    get academicYear(): string | null {
        return this.props.academicYear?.getValue() ?? null;
    }

    get semester(): number | null {
        return this.props.semester;
    }

    get level(): number | null {
        return this.props.level;
    }

    get isApproved(): boolean {
        return this.props.isApproved;
    }

    get isReviewed(): boolean {
        return this.props.isReviewed;
    }

    get isInterimAssessment(): boolean {
        return this.props.isInterimAssessment;
    }

    get isSupplementary(): boolean {
        return this.props.isSupplementary;
    }

    get processingStatus(): ProcessingStatus {
        return this.props.processingStatus;
    }

    get courseDescription(): string | null | undefined {
        return this.props.courseDescription;
    }

    get department(): string | null | undefined {
        return this.props.department;
    }

    get createdAt(): Date {
        return this.props.createdAt;
    }

    get updatedAt(): Date {
        return this.props.updatedAt;
    }

    get uploadedBy(): UploadedBy | undefined {
        return this.props.uploadedBy;
    }

    get universityId(): string {
        return this.props.universityId;
    }

    // ✅ Domain behavior (example)
    markAsApproved(): void {
        this.props.isApproved = true;
        this.touch();
    }

    markAsReviewed(): void {
        this.props.isReviewed = true;
        this.touch();
    }

    markForReview(): void {
        this.props.isReviewed = false;
        this.touch();
    }

    updateProcessingStatus(status: ProcessingStatus): void {
        this.props.processingStatus = status;
        this.touch();
    }

    private touch(): void {
        this.props.updatedAt = new Date();
    }
}
